var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 9,
    viewBox: "0 0 3 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50071 6.75C1.8262 6.75 2.13836 6.86853 2.36852 7.0795C2.59868 7.29048 2.72798 7.57663 2.72798 7.875C2.72798 8.17337 2.59868 8.45952 2.36852 8.6705C2.13836 8.88147 1.8262 9 1.50071 9C1.17522 9 0.863056 8.88147 0.632898 8.6705C0.402739 8.45952 0.273438 8.17337 0.273438 7.875C0.273438 7.57663 0.402739 7.29048 0.632898 7.0795C0.863056 6.86853 1.17522 6.75 1.50071 6.75ZM1.50071 3.375C1.8262 3.375 2.13836 3.49353 2.36852 3.70451C2.59868 3.91548 2.72798 4.20163 2.72798 4.5C2.72798 4.79837 2.59868 5.08452 2.36852 5.29549C2.13836 5.50647 1.8262 5.625 1.50071 5.625C1.17522 5.625 0.863056 5.50647 0.632898 5.29549C0.402739 5.08452 0.273438 4.79837 0.273438 4.5C0.273438 4.20163 0.402739 3.91548 0.632898 3.70451C0.863056 3.49353 1.17522 3.375 1.50071 3.375ZM1.50071 0C1.8262 0 2.13836 0.118526 2.36852 0.329505C2.59868 0.540483 2.72798 0.826631 2.72798 1.125C2.72798 1.42337 2.59868 1.70952 2.36852 1.9205C2.13836 2.13147 1.8262 2.25 1.50071 2.25C1.17522 2.25 0.863056 2.13147 0.632898 1.9205C0.402739 1.70952 0.273438 1.42337 0.273438 1.125C0.273438 0.826631 0.402739 0.540483 0.632898 0.329505C0.863056 0.118526 1.17522 0 1.50071 0Z",
    fill: "#77787B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/Dots.354a835284475464af625fbcf16bd353.svg";
export { ForwardRef as ReactComponent };